export default class Share {
  constructor() {
    this.FB_ID = window.ULIEGE_FB_ID || '382136236312849';
    console.info(this.FB_ID);
    this.bind();
  }

  bind() {
    this.onClick = this.onClick.bind(this);
    document.addEventListener('click', this.onClick);
  }

  onClick(e) {
    let el = e.target;

    while (el && (!el.dataset || !el.dataset.share)) {
      el = el.parentNode;
    }

    if (el && el.dataset && el.dataset.share) {
      e.preventDefault();
      e.stopPropagation();
      const type = el.dataset.share;

      if (type === 'facebook') {
        this.openFacebook();
      }

      if (type === 'linkedin') {
        this.openLinkedin();
      }

      if (type === 'twitter') {
        this.openTwitter(window.location.href, el.dataset.text, el.dataset.via);
      }
    }
  }

  openFacebook(uri = window.location.href) {
    const href = this.e(uri);
    const url = `https://www.facebook.com/dialog/share?app_id=${this.FB_ID}&display=popup&href=${href}`;

    return this.openPopup(url, 'Share on Facebook', 575, 300);
  }

  openTwitter(uri = window.location.href, rawText = '', account = '') {
    const text = this.e(rawText);
    const via = this.e(account);

    const href = this.e(uri);
    const url = `https://twitter.com/intent/tweet?url=${href}&text=${text}&via=${via}`;

    return this.openPopup(url, 'Share on Twitter', 550, 255);
  }

  openLinkedin(uri = window.location.href) {
    const href = this.e(uri);
    const url = `https://www.linkedin.com/shareArticle?mini=true&url=${href}`;

    return this.openPopup(url, 'Share on Linkedin', 550, 255);
  }

  openPopup(url, title, width, height) {
    const left = (window.screen.width - width) / 2;
    const top = (window.screen.height - height) / 2;

    return window.open(
      url,
      title,
      `status=no,resizable=yes,height=${height},width=${width},top=${top},left=${left},toolbar=no,menubar=no,location=no,directories=no`
    );
  }

  e(text) {
    return window.encodeURIComponent(text);
  }
}
